<div class="meta-config-panel admin-theme" (click)="$event.stopPropagation()">
  <button (click)="removeStyle()" class="full-width">Zurücksetzen</button>
  
  @if(eType() === elementsType.Text) {
    <div class="meta-config-item">
      <button (click)="openAdvancedEditor()">
        Erweiterte Textbearbeitung
      </button>
    </div>
  }
  
  @for(style of styles(); track style.label) {
  <label>
    <span class="mat-label-medium text-color">{{ style.label }}:</span>
  </label>
  <div class="meta-config-item ">
    @if(style.options && style.options.length > 0) {
      <div class="select-container">
        <mat-select [(ngModel)]="style.value" (selectionChange)="updateStyle($event.value, style)" panelClass="admin-theme">
          <mat-option *ngFor="let option of style.options" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </div>
    } @else {
    <input [type]="style.inputType" [value]="style.value" (input)="updateStyle($event, style)" [min]="style.min"
      [max]="style.max" class="full-width"/>
    }
    @if(style.inputType === 'color' && style.type == 'background-color') {
    <button (click)="updateStyle('transparent', style)">Transparent</button>
    }

  </div>
  
  }
  <button (click)="close()" class="full-width">Schließen</button>
</div>